<template>
  <div class="sum-table-all-height" :id="tableId" :style="overflowTable.x ? 'height: 100%;' : ''">
    <el-table
      v-if="merge && merge.length > 0"
      border
      ref="overTable"
      :stripe="true"
      :header-cell-style="getHeaderCellStyle()"
      :cell-style="getCellStyle"
      :cell-class-name="cllNameFun"
      :span-method="arraySpanMethod"
      :data="[...allData, ...tableData]"
      :row-style="getRowClass"
      :height="overHeights"
      style="width: 100%"
      highlight-selection-row
      @current-change="handleCurrentChange"
      @header-dragend="headerDragend"
      @cell-click="columnClick">
      <template v-if="merge && merge.length > 0">
        <summaryTable :list="list"
                      label="label"
                      v-for="(list, listIndex) in merge"
                      :oneInd="listIndex === merge.length - 1"
                      :key="index + '_' + listIndex"
                      :tableIndex="index"
                      :valueConfig="valueConfig"
                      :rowLen="row.length"
                      :lineClamp="lineClamp"
                      :formdatas="tableData"
                      :rowWidth="rowWidth"
                      :summaryObj="summaryObj"
                      :sumWidth="sumWidth"
                      @goSearch="goSearch"
                      @setReviseRow="rSetReviseRow"
                      @rSetReviseRow="rSetReviseRow"
                      :reviseObj="reviseObj"
                      :config="config"
                      :dashboardId="dashboardId"
                      :isPartition="isPartition"
                      :isLeft="listIndex === 0 && overflowTable.y ? true : false"></summaryTable>
<!--        :key="subNumber(index)"-->
      </template>
    </el-table>
  </div>
</template>

<script>
  import summaryTable from './summaryTable.vue'
  export default {
    name: "sumTable",
    // row 行数据 isSummary 是否汇总 tableData 结果 mergeTable 行列用的 merge 多级头结构 overflowTable 冻结行列 index 类似id作用 isFrontEnd 是否后端展示 true是false否
    props: {
      //- 汇总表id
      id: {
        type: Number,
        default: 0
      },

      isSummary: {
        type: Number,
        default: 2
      },
      tableData: {
        type: Array || Object,
        default: []
      },
      mergeTable: {
        type: Array,
        default: () => []
      },
      merge: {
        type: Array,
        default: () => { return [] }
      },
      overflowTable: {
        type: Object,
        default: () => { return {  x: false, y: false } }
      },
      index: {
        type: String || Number
      },
      isFrontEnd: {
        type: Boolean,
        default: false
      },
      totalPage: {
        type: Number
      },
      page: {
        type: Number
      },
      total: {
        type: Number,
        default: 0
      },
      row: {
        type: Array,
        default: ()=>[]
      },
      column:{
        type: Array,
        default: ()=>[]
      },
      summary:{
        type: Array,
        default: ()=>[]
      },
      topCount: {
        type: Number,
        default: ()=> 0
      },
      selectRow: {
        type: Number,
        default: ()=>null
      },
      selectCloum: {
        type: Number,
        default: ()=>null
      },
      selectPage: {
        type: Number,
        default: ()=>1
      },
      // 放联系人的
      user: {
        type: Array,
        default: () => []
      },
      lineClamp: {
        type: Number,
        default: 1
      },
      // 表头配置
      titleConfig: {
        type: Object,
        default: () => {}
      },
      // 值配置
      valueConfig: {
        type: Object,
        default: () => {}
      },
      rowWidth: {
        type: Object,
        default: () => {}
      },
      summaryObj: {
        type: Object,
        default: () => {}
      },
      config: {
        type: Object,
        default: () => {}
      },
      reviseObj: {
        type: Object,
        default: () => {}
      },
      dashboardId: String,
      saveRevise: Boolean,
      isPartition: Boolean
    },
    components: {
      summaryTable
    },
    data () {
      return {
        overHeights: '100%',
        // selectRow: null,
        // selectCloum: null,
        tableWidth: null,
        sumWidth: '',
        allData: [],
        isModified: false
      }
    },
    watch: {
      "overflowTable.x" (val) {
        if (val) {
          this.overHeights = '100%';
        } else {
          this.overHeights = '';
        }
      },
      "tableData" () {
        if (this.overflowTable.x) {
          this.overHeights = '100%';
        } else {
          this.overHeights = '';
        }
      },
      tableWidth: {
        immediate: true,
        deep: true,
        handler (val) {
          console.log('总宽度有了', val)
          if (val) {
            this.getWidthS(val)
          }
        }
      },
      'config.upRevise': {
        handler (val) {
          if (val) {
            // const data = cloneDeep(this.tableData[0])
            
            // for (const key in a) {
            //   if (key === 'rowIndex') {
            //   } else {
            //     data[key] = '全选'
            //   }
            // }
            const data = {
              [this.row[this.row.length - 1].name]: '全选',
              isAll: true
            }
            const index = Number(this.index)
            const insertIndex = index === 0 ? 0 : this.tableData.length + index
            this.mergeTable.forEach(item => {
              item.splice(insertIndex, 0, 1)
            })
            this.allData = [data]
            this.isModified = true
          } else {
            if (this.isModified) {
              const index = Number(this.index)
              const insertIndex = index === 0 ? 0 : this.tableData.length
              this.mergeTable.forEach(item => {
                item.splice(insertIndex, 0, 1)
              })
              this.allData = []
              this.isModified = false
            }
          }
        },
        immediate: true,
        deep: true
      }
    },
    mounted () {
      try {
        const overTable = this.$refs.overTable
        const allWidth = overTable.$el.clientWidth
        this.tableWidth = allWidth
      } catch (err) {
        console.log('查询错误', err)
      }
    },
    computed: {
      tableId () {
        return this.config ? this.config.datasName + '_' + this.config.i + '_' +  (this.index || 0) : ''
      }
    },
    methods: {
      rSetReviseRow (config) {
        const rInd = this.isPartition ? config.row.rowIndexNew : config.row.rowIndex
        if (this.user && this.user[rInd]) config.row = { ...config.row, ...this.user[rInd] }
        this.$emit('rSetReviseRow', {...config, i: this.config.i })
      },
      getWidthS (val) {
        console.log('返回过来的宽度查询', val)
        // 计算开掉的宽度
        let w = 0
        if (this.row && this.row.length > 0) {
          for (const i of this.row) {
            if (this.rowWidth[i.name]) {
              const r = this.rowWidth[i.name].split('px')[0]
              w += r
            } else {
              w += 160
            }
          }
        } else {
          w = 160
        }
        // 如果行字段，自适应
        switch (this.config.rowWidthConfig || '') {
          case 'adaptive': {
            const sumCount = this.config.sumCount
            const ww = (val - w) / sumCount
            this.sumWidth = ww  + 'px'
            break
          }
          case 'customize':
          this.sumWidth = this.config.rowFieldWidth + 'px'
            break
        }
      },
      // getAllWidth () {
      //   try {
      //     const overTable = this.$refs.overTable
      //     const allWidth = overTable.$el.clientWidth
      //     let sw = 0
      //     let lw = 0
      //     if (this.column && this.column.length > 0) {
      //       lw = this.getWidth([this.column[0]], overTable.$el)
      //     } else if (this.row && this.row.length > 0) {
      //       lw = this.getWidth(this.row, overTable.$el)
      //     }
      //     // this.tableWidth = this.$refs.overTable.$el.clientWidth
      //     console.log('内容', allWidth, lw)
      //   } catch (err) {
      //     console.log('查询错误', err)
      //   }
      // },
      // getWidth (arr, demo) {
      //   console.log('跑款', demo)
      //   if (!demo) return 0
      //   let w = 0
      //   for (const i of arr) {
      //     const d = demo.getElementsByClassName(i.name)
      //     if (d && d > 0) {
      //       w += d[0].clientWidth
      //     }
      //   }
      //   return w
      // },
      goSearch(data = {}) {
        const { filed = {}, info = {} } = data
        const { label } = filed
        const { type: infoType, value } = info
        const orderValue = {
          positiveSequence: 'asc',
          reverseOrder: 'desc'
        }
        const query = []
        const order = []
        if (infoType === 'order') {
          const obj = {}
          obj.key = orderValue[value] 
          obj.value = orderValue[value] 
          obj.feild = label
          obj.setting = label
          order.push(obj)
        } else {
          const obj = {}
          obj.value = [value]
          obj.relation = 'in'
          obj.field = label
          if (value) {
            query.push(obj)
          }
        }
        this.$emit('goSearch', { query, order, id: this.id })
      },
      handleCurrentChange (val) {
        this.$emit('selectedTable', {val: val, index: this.selectedKey})
      },
      getHeaderCellStyle () {
        const ob = { background: '#f8f9fb', color: '#333', fontWeight: 'normal', ...this.titleConfig }
        if (this.config && this.config.bgfillStyle && this.config.bgfillStyle.columnBgstyle) {
          if (this.config.bgfillStyle.columnBgstyle === 'color' && this.config.bgfillStyle.columnColor) {
            ob.background = this.config.bgfillStyle.columnColor
          } else if (this.config.bgfillStyle.columnBgstyle === 'picture' && this.config.bgfillStyle.columnPicture && this.config.bgfillStyle.columnPicture.url) {
            ob.background = 'url(' + this.$imgurl + this.config.bgfillStyle.columnPicture.url + ')'
            if (this.config.bgfillStyle.columnPicture.layout === 'adaption') ob.background += ' 0% 0% / cover no-repeat'
          }
        }
        return ob
      },
      getCellStyle (val) {
        const { columnIndex } = val
        const rrr = columnIndex < this.row.length ? this.titleConfig : this.valueConfig
        const oo = {...this.cllStyleFun(val),  ...rrr }
        if (this.row && this.row[0] && this.row[0].partition && val.columnIndex < this.row.length - 1) {
          oo.backgroundColor = '#f8f9fb'
        }
        return oo
      },
      headerDragend (newWidth, oldWidth, column, event) {
        const name = column.label
        const ind = this.row.findIndex(its => its.revisabilityName === name)
        console.log('查询当前宽度拖拽的', newWidth, oldWidth, column, event, ind)
        if (ind !== -1) this.$emit('setWidth', {name: name, width: newWidth})
      },
      //- 汇总表清除点击效果事件
      clearSelect() {
        // this.selectRow = null;
        // this.selectCloum = null;
      },
      //- 检查特殊字符
      containSpecial(str) {
        var containSpecial = RegExp(
          // eslint-disable-next-line no-useless-escape
          /[(\ )(\~)(\!)(\@)(\#)(\$)(\%)(\^)(\&)(\*)(\()(\))(\-)(\+)(\=)(\[)(\])(\{)(\})(\|)(\\)(\;)(\:)(\')(\")(\,)(\.)(\/)(\<)(\>)(\?)(\)]+/
        );
        return containSpecial.test(str);
      },
      //- 当某个单元格被点击时会触发该事件
      columnClick(row, column, cell, event){
        //- row：行数据，column：当前列字段参数，cell：dom元素内容，event：鼠标mouseEvent事件
        console.log('点击', row, column, cell, event)

        let value = row[column.property];
        console.log('点击设置', value)
        if((!value || value == undefined || cell.className.indexOf("cllDark") != -1) && value !== 0){
          return;
        }
        let pushDatas = {};
        let columnArray = this.column;
        let rowArray = this.row;
        let summary = this.summary;
        //- 当前点击的汇总数值
        let new_summary = [];
        summary.forEach(item => {
          if(item.name.indexOf(column.label) != -1){
            new_summary.push(item)
          }
        })
        pushDatas[new_summary[0].name] = value;
        // console.log("summary_pushDatas",JSON.parse(JSON.stringify(pushDatas)))

        //- 当前点击的行数据
        rowArray.forEach(item => {
          pushDatas[item.name] = row[item.name]
        })
        // console.log("row_pushDatas",JSON.parse(JSON.stringify(pushDatas)))


        //- 当前点击的列数据
        columnArray.forEach(item => {
          let columnData = row[item.name];
          let property = column.property;
          if(columnData && columnData.length>0) {
            columnData.forEach(item2 => {
              if(property.indexOf(item2) != -1) {
                pushDatas[item.name] = item2;
              }
            })
          }
          // pushDatas[item.name] = row[item.name];
        })
        // console.log("column_pushDatas",JSON.parse(JSON.stringify(pushDatas)))

        const rInd = this.isPartition ? row.rowIndexNew : row.rowIndex

        let date = {
          id: this.id,
          value: pushDatas,
          selectRow: rInd,
          selectCloum: column.columnIndex,
          selectPage: this.page,
          label: column.label
        }
        if (this.user && this.user[rInd]) date.user = this.user[rInd]
        // console.log("date",date)
        // return;
        console.log('点击返回summary', date)
        this.$emit("relevanceFun",date)
      },
      //- 表格背景色斑马纹
      getRowClass({rowIndex}){
        if(rowIndex%2 ==0){
          //- 偶数
          return '';
        }else{
          //- 奇数
          return 'background:#F4F8FF;';
        }
      },
      subNumber (val) {
        return val + '_' + parseInt((Math.random() * 9 + 1) * 100000);
      },
      // 单元格样式调整
      cllStyleFun ({row, column, rowIndex, columnIndex}) {
        // console.log('单元格样式', row, column, rowIndex, columnIndex);
        row.rowIndex = rowIndex;
        column.columnIndex = columnIndex;
        let cc = {}
        //- 选中效果
        if(this.selectRow === rowIndex && columnIndex === this.selectCloum && this.page == this.selectPage){
          // return {background: '#19B359',color: '#FFFFFF'};
          cc = {background: '#19B359',color: '#FFFFFF'};
        }
        //- 设置表单头部标题内容
        if (JSON.stringify(cc) !== '{}' && this.row.length > 0 && this.row.length > columnIndex) {

          return {background: '#f8f9fb',color: '#333',cursor: 'default'};
          // cc = {background: '#f8f9fb',color: '#333',cursor: 'default'};
        }
        if (this.config && this.config.reviseConfig && this.config.reviseConfig.required && this.config.upRevise && this.config.row.length <= columnIndex && this.saveRevise) {
          const reviseList = this.config.reviseConfig.config.map(it => it.name)
          const label = column.property
          const val = row[label]
          const label1 = label + '' + row.rowIndex

          if ((!this.reviseObj || !this.reviseObj[label1]) && !reviseList.includes(val)) {
            cc.backgroundColor = 'rgba(255, 48, 48, 0.05)'
            cc.border = '1px solid #FFAEAE'
          }
        }
        if (this.config && this.config.bgfillStyle && this.config.bgfillStyle.rowBgstyle && (this.config && this.config.reviseConfig && this.config.reviseConfig.required && this.config.upRevise && this.config.row.length <= columnIndex && this.saveRevise || this.row.length > 0 && this.row.length > columnIndex)) {
          let color = '#f8f9fb'
          if (this.config.bgfillStyle.rowBgstyle === 'color' && this.config.bgfillStyle.rowColor) {
            color = this.config.bgfillStyle.rowColor
          } else if (this.config.bgfillStyle.rowBgstyle === 'picture' && this.config.bgfillStyle.rowPicture && this.config.bgfillStyle.rowPicture.url) {
            color = 'url(' + this.$imgurl + this.config.bgfillStyle.rowPicture.url + ')'
            if (this.config.bgfillStyle.rowPicture.layout === 'adaption') color += ' 0% 0% / cover no-repeat'
          }
          cc.background = color
        }
        return cc
      },
      //- 单元格名称调整
      cllNameFun({ column, rowIndex, columnIndex}){
        //- 标题判断
        if (Number(this.isSummary) === 1 && (this.tableData.length - 1) === rowIndex && this.totalPage === this.page) {
          return "cllDark";
        }
        //- 底部汇总判断
        if (this.row.length > 0 && this.row.length > columnIndex) {
          return "cllDark";
        }
        //- 右边汇总判断
/*
        let rowNumber = this.topCount;
        // console.log("rowNumber",columnIndex,rowNumber);
        if(this.row.length>1){
          rowNumber += 1;
        }
        if (Number(this.isSummary) === 1 && (columnIndex - rowNumber)>0) {
          console.log('右边汇总判断', columnIndex, rowNumber, rowIndex, row,column)
          return "cllDark";
        }
*/
        const property = column.property
        if (Number(this.isSummary) === 1 && property.substring(property.length - 2, property.length) === '汇总') {
          return "cllDark";
        }

        // row.clickStu = true;


      },
      arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
        if (this.row.length > 1 && columnIndex < (this.row.length - 1)) {
          if (this.mergeTable.length > 0) {
            let merVal = this.mergeTable[columnIndex][rowIndex];
            let merValTwo = merVal === 0 ? 0 : 1;
            // 如果是最后一页的最后一行并且需要显示汇总
            if (Number(this.isSummary) === 1 && (this.tableData.length - 1) === rowIndex && this.totalPage === this.page && !this.isPartition) {
              if (columnIndex === 0) {
                merValTwo = this.row.length;
              } else {
                merValTwo = 0;
              }
            }
            // 如果当前行是横向汇总的
            if (row.isPool && row.isPool === true) {
              // 计算当前处于哪个汇总
              // 查询当前汇总字段是处于row 弟几级，需要把前面的减掉才行
              const ind = this.row.findIndex(it => it.name === column.label && row[it.name])
              if (ind !== -1 && this.row[ind].name === column.label) {
                merValTwo = this.row.length - ind
              }
            }
            if (row.isAll) {
              // merValTwo = this.row.length
            }
            merVal = this.config.upRevise && merVal === undefined ? 1 : merVal
            return {
              rowspan: merVal,
              colspan: merValTwo
            }
          }
        }

          // 如果汇总存在，最后一行合并
        if (Number(this.isSummary) === 1 && this.row.length > 1 && this.totalPage === this.page) {
          if (columnIndex === 0) {
            if ((this.tableData.length - 1) === rowIndex) {
              // console.log('最后一个')
              return [1, this.row.length];
            } else {
              return [1,1]
            }
          } else if (columnIndex < this.row.length) {
            if ((this.tableData.length - 1) === rowIndex) {
              return [0,0];
            } else {
              return [1,1]
            }
          }
        }
      },

    }
  }
</script>

<style scoped lang="scss">
:deep(.el-table .el-table__cell.is-hidden>*) {
  visibility: visible !important;
}
  .sum-table-all-height {
    margin-left: auto;
    margin-right: auto;
    /*height: 100%;*/
    :deep(table td) {
      cursor: pointer;

    }
  }
  :deep(.selectArea) {
    background-color: #19B359 !important;
    color: white !important;
    &:hover {
      background-color: #19B359 !important;
      color: white !important;
    }
  }
</style>
